import { render } from "./OfferQuickPanel.vue?vue&type=template&id=d8520dde&scoped=true"
import script from "./OfferQuickPanel.vue?vue&type=script&lang=js"
export * from "./OfferQuickPanel.vue?vue&type=script&lang=js"

import "./OfferQuickPanel.vue?vue&type=style&index=0&id=d8520dde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8520dde"]])

export default __exports__